const InputLengthValidation = (rule, value, callback, name, length) => {
  if (value && value.trim().length < length) {
    callback(`${name}  should contain at least ${length} characters`);
  } else callback();
};

export default InputLengthValidation;
